import { render, staticRenderFns } from "./speed-chart.vue?vue&type=template&id=52c9fa8e&scoped=true&"
import script from "./speed-chart.vue?vue&type=script&lang=ts&"
export * from "./speed-chart.vue?vue&type=script&lang=ts&"
import style0 from "./speed-chart.vue?vue&type=style&index=0&id=52c9fa8e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c9fa8e",
  null
  
)

export default component.exports